import { render, staticRenderFns } from "./dialogBrandedFares.vue?vue&type=template&id=0478046a&"
import script from "./dialogBrandedFares.vue?vue&type=script&lang=js&"
export * from "./dialogBrandedFares.vue?vue&type=script&lang=js&"
import style0 from "./dialogBrandedFares.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports